const timer = {
  /** Introduction */
  set_a_time_limit_start_the_timer_and_watch_it_count_down_to_0_to_time_group_activities_discussions_or_simply_take_a_time_out_pause_and_restart_as_per_your_convenience:
    'Set a time limit, start the timer and watch it count down to 0. To time group activities, discussions, or simply take a time out. Pause and restart as per your convenience',

  /** timer page */
  untitled_timer: 'Untitled timer',
  add_background_image: 'Add background image',
  uploaded_image_is_larger_than_maximum_allowed_size_of_N_mb:
    'Uploaded image is larger than maximum allowed size of {{count}} MB',
  uploaded_file_is_not_supported_supported_image_extensions_are_allowed_extensions:
    'Uploaded file is not supported. Supported image extensions are {{allowedExtensions}}',

  /** slide */
  timer_was_not_started: 'Timer was not started',
  // DO NOT USE \n as it raises many bugs in PowerPoint code
  title_timer_ran_for_minutes_count_minutes_seconds_count_seconds:
    '{{title}} \r Timer ran for {{minutesCount}} minutes {{secondsCount}} seconds',
} as const;

export default timer;
